import React, {useEffect} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {usePages} from '../../hooks/index.mjs';
import {LandingPageContext} from '../index.mjs';
import {PAGE_TYPES, pageAnimationCompleted, useDispatch} from '../../state/index.mjs';
import SurveyPageContext from './SurveyPageContext';
import ProductPageContext from './ProductPageContext';

const DemoPageContainer = (props) => {
  const {
    className,
    LandingPage,
    SurveyPage,
    SummaryPage,
    DetailsPage,
  } = props;

  const dispatch = useDispatch();
  const { currentPageType, currentPageUrl } = usePages();
  const componentClass = 'pageContainer';
  const classes = classnames(componentClass, className);

  useEffect(() => {
    dispatch(pageAnimationCompleted());
  }, [currentPageUrl]);

  const renderPage = () => {
    switch(currentPageType) {
      case PAGE_TYPES.surveyPage:
        return <SurveyPageContext Component={SurveyPage} />;
      case PAGE_TYPES.summaryPage:
        return <ProductPageContext Component={ SummaryPage } />;
      case PAGE_TYPES.detailsPage:
        return <ProductPageContext Component={ DetailsPage } />;
      default:
        return <LandingPageContext Component={LandingPage} />;
    }
  };

  return (
    <div role="main" >
      <div className={classes}>
        { renderPage() }
      </div>
    </div>
  );
};

DemoPageContainer.propTypes = {
  className: PropTypes.string,
  LandingPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  SurveyPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  SummaryPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  DetailsPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

export default DemoPageContainer;
